// extracted by mini-css-extract-plugin
module.exports = {"button":"profile-logout_button__Mdq8v","buttonText":"profile-logout_buttonText__dFuOH","buttonIcon":"profile-logout_buttonIcon__zx0d1"};